define(function (require) {
    var ko = require("knockout");

    ko.extenders.defaultOnNull = function (target, defaultValue) {
        var result = ko.computed({
            read: target,
            write: function (newValue) {
                if (newValue && newValue !== defaultValue) {
                    // does this need to check for && newValue !== defaultValue?
                    target(newValue);
                } else {
                    target(defaultValue);
                }
            }
        });

        result(target());

        return result;
    };

    // if you need to add more here, maybe try ChatGPT, first.
});
